import dayjs from "dayjs";
import { formatCurrency } from "../../../../utils";

const last7Days = Array.from({ length: 7 }).map((_, i) =>
    dayjs().subtract(6 - i, 'day').format('DD MMM') // e.g., "17 Jul"
);

export const stockTrendOptions = {
    chart: {
        type: 'line',
        height: 60,
        sparkline: { enabled: true }
    },
    stroke: {
        curve: 'smooth',
        width: 2
    },
    colors: ['#1e88e5'],
    tooltip: {
        fixed: {
            enabled: false
        },
        x: { show: false },
        y: {
            title: {
                formatter: () => null
            },
            formatter: (val) => formatCurrency(val)
        },
        marker: { show: false }
    }
};

export const orderTrendOptions = {
    chart: {
        type: 'line',
        height: 60,
        sparkline: { enabled: true }
    },
    stroke: {
        curve: 'smooth',
        width: 2
    },
    colors: ['#43a047'],
};


export const itemsTrendOptions = {
    chart: {
        type: 'line',
        height: 60,
        sparkline: { enabled: true }
    },
    stroke: {
        curve: 'smooth',
        width: 2
    },
    colors: ['#ff7043'],
    tooltip: {
        custom: ({ dataPointIndex }) => {
            const categories = last7Days;
            const label = categories[dataPointIndex] || '';
            return `<div class="apex-tooltip-custom">${label}</div>`;
        },
        marker: { show: false }
    },
    xaxis: {
        categories: last7Days
    }
};

export const warehouseUsageOptions = {
    chart: {
        type: 'bar',
        stacked: true,
        height: 100,
        sparkline: { enabled: true }
    },
    plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: '50%',
            borderRadius: 3,
            dataLabels: {
                position: 'bottom',
            }
        },
    },
    xaxis: {
        categories: ['Ambient', 'Frozen', 'Chilled'],
    },
    yaxis: {
        max: 100,
        labels: { show: false },
    },
    legend: { show: false },
    tooltip: {
        y: {
            formatter: val => `${val}%`
        }
    },
    dataLabels: {
        enabled: true,
        enabledOnSeries: [0],
        formatter: (val, { seriesIndex, dataPointIndex, w }) =>
            seriesIndex === 0 ? w.globals.labels[dataPointIndex] : '',
        style: {
            fontSize: '12px',
            fontWeight: 600,
            colors: ['#fff']
        }
    },
    fill: {
        opacity: 1
    },
    colors: [
        ({ dataPointIndex, seriesIndex }) => {
            if (seriesIndex === 0) {
                return ['#f9bd5b', '#39c2d2', '#4395c5'][dataPointIndex];
            }
            return '#e0e0e0';
        }
    ],
    states: {
        normal: {
            filter: { type: 'none' }
        },
        hover: {
            filter: {
                type: 'darken',
                value: 0.15,
            }
        },
        active: {
            allowMultipleDataPointsSelection: false,
            filter: {
                type: 'darken',
                value: 0.2,
            }
        }
    },
    responsive: [
        {
            breakpoint: 480,
            options: {
                dataLabels: {
                    style: {
                        fontSize: '9px',
                        fontWeight: 300,
                    }
                },
            }
        }
    ]
};

export const turnoverOptions = {
    chart: {
        type: 'line',
        height: 60,
        sparkline: { enabled: true }
    },
    stroke: {
        curve: 'smooth',
        width: 2
    },
    tooltip: {
        x: { show: false },
        y: {
            title: {
                formatter: () => 'Turnover:'
            },
            formatter: (val) => `${val.toFixed(1)}x`
        }
    },
    colors: ['#ff7043']
};
